// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-spinkit/css/base.css
// module id = 1226
// module chunks = 0